import ErrorFromArray from "./ErrorFromArray";
import ErrorFromString from "./ErrorFromString";

export default function createError(type, dataError) {
	const errorClasses = {
		array: ErrorFromArray,
		string: ErrorFromString,
	};
	const ErrorClass = errorClasses[type];
	if (!ErrorClass) {
		throw new Error("Invalid error type");
	}
	return new ErrorClass(this, dataError);
}
